export default __webpack_public_path__ + "static/media/active-warning.b9b55e7b.svg";